"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformApiClientsApi = exports.SdPlatformApiClientsQueryEmbeddableFields = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const ResourcesApi_1 = require("./commons/ResourcesApi");
/**
 * The embeddable fields for query parameter.
 */
var SdPlatformApiClientsQueryEmbeddableFields;
(function (SdPlatformApiClientsQueryEmbeddableFields) {
})(SdPlatformApiClientsQueryEmbeddableFields = exports.SdPlatformApiClientsQueryEmbeddableFields || (exports.SdPlatformApiClientsQueryEmbeddableFields = {}));
/**
 * API client operations (API clients of the platform backend).
 */
class SdPlatformApiClientsApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "apiclients";
    }
    /**
     * Query the api clients.
     * @param query - {@link SdPlatformApiClientsQueryParameters} optional query parameters
     * @returns query result
     */
    query(query = {}) {
        return super.__query(SdPlatformRequestId_1.RequestId.ApiClientQuery, query);
    }
    /**
     * Create a new api client.
     * @param body - {@link SdPlatformRequestApiClientCreate} body or parameters for create request.
     * @returns returns created api client response.
     */
    create(body) {
        return super.__post(SdPlatformRequestId_1.RequestId.ApiClientCreate, body);
    }
    /**
     * Patch an api client
     * @param id
     * @param body - {@link SdPlatformRequestApiClientPatch} body or patch parameters.
     * @returns patch response.
     */
    patch(id, body) {
        return super.__patch(SdPlatformRequestId_1.RequestId.ApiClientPatch, id, body);
    }
    /**
     * Delete an api client.
     * @param id
     * @returns delete response.
     */
    delete(id) {
        return super.__delete(SdPlatformRequestId_1.RequestId.ApiClientDelete, id);
    }
}
exports.SdPlatformApiClientsApi = SdPlatformApiClientsApi;
//# sourceMappingURL=SdPlatformApiClientsApi.js.map